import React, { useEffect, useLayoutEffect } from "react";
import { IoChevronBack } from "react-icons/io5";
// custom component
import SongCard from "../../components/reusable/SongCard";
// loading state
import Loading from "../../components/loading";
import HomePageSkeleton from "../../components/skeletonLoading/HomePageSkeleton";

import FlatList from "../../components/FlatList";

// custom context
import { useNavbar } from "../../context/NavBarContext";

import { NotFound } from "../error/NotFound_404";

import { useFetchMusicArtistSongDataQuery } from "../../api/musicArtistSongPageApi";
import { useParams } from "react-router";

import { useMusic } from "../../context/MusicContext";

const Index = () => {
  const musicContext = useMusic();
  const Navbar = useNavbar();
  const { artist_id } = useParams();

  useLayoutEffect(() => {
    Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
  },[])

  const { data, error, isLoading, isFetching } =
    useFetchMusicArtistSongDataQuery({
      artist_id: artist_id,
    });

  useLayoutEffect(() => {
    Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
  }, []);
  useEffect(() => {
    if (data) {
      let copyData = data.result.filter((music) => music.can_play == 1);
      musicContext.setDummyPlayList(copyData);
    }
  }, [data]);

  if (isLoading) {
    return <HomePageSkeleton />;
  }

  if (error) {
    return <NotFound error={error} />;
  }

  return (
    <>
      {data?.result?.map((item) => (
        <SongCard key={item.id} item={item} />
      ))}
    </>
  );
};

export default Index;
